import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, { props } ) => ( {
	container: {
		borderRadius: "10px"
	},
	feedContainer: {
		borderTopLeftRadius  : props?.listId === 0 ? "10px" : "0px",
		borderTopRightRadius : props?.listId === 0 ? "10px" : "0px",
		padding              : !( props?.checkPageRoute ( "video" ) ) && "2rem 2rem 0rem 2rem",
		borderBottom         : ( props?.checkPageRoute ( "home" ) || props?.checkPageRoute ( "profile" ) ) && `1px solid ${ theme.other.colors.border.primary }`,
		wordBreak            : "break-word"
		// width                : "45vw",
		// margin               : "auto",
		// maxWidth             : "600px"
	}
} ) );
